// NACA-Core keeps spreadsheet rows that have data but no ID (its importer used
// to drop them silently) and sends them with an empty Key. Kids Zone treats
// Key as a real identifier -- Number(d.Key) in filters, loc.Key - 1 in
// navigation, dedupe by Key -- so a row without one isn't ready for the games
// yet. Skip it here, where NACA data first comes in, before anything reads it.
//
// Only an explicitly empty Key ("" or null) counts as "no ID". An entry with
// no Key field at all keeps going to getData's existing index fallback.
export const dropKeylessEntries = (items) =>
  items.filter((item) => item.Key !== "" && item.Key !== null);

// Kids Zone was built against Firestore, which stored sheet cells TYPED:
// number-looking cells as numbers, TRUE/FALSE as booleans. NACA-Core sends
// every cell as text, which silently breaks code written for numbers --
// e.g. index.js keeps a game only if isNaN(d.Key.length) (true for a number,
// false for text), so the game picker came up empty, and "2" + 1 is "21".
// This restores Firestore's types where NACA data first comes in.
//
// Checked against every NACA-mode community's real Firestore data
// (2026-10-05: Red Lake, Salish, Pokagon, Westbank): this rule reproduces
// Firestore's type for every field in the game-config tabs (GoldStar,
// GameFilterDataNew, uiWords, PopupWords) with zero mismatches. The fields
// below are the exception -- Firestore always kept them as text, even when
// the cell looked like a number ("1" as an English word), so they stay text.
const ALWAYS_TEXT = new Set(["English", "Language", "App_Audio", "App_Art", "Person Subj", "Person Object"]);
const NUMBER = /^-?\d+(\.\d+)?$/;

const typeValue = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (NUMBER.test(trimmed)) return Number(trimmed);
  if (trimmed === "TRUE") return true;
  if (trimmed === "FALSE") return false;
  return value;
};

export const typeLikeFirestore = (items) =>
  items.map((item) =>
    Object.fromEntries(
      Object.entries(item).map(([key, value]) => [key, ALWAYS_TEXT.has(key) ? value : typeValue(value)])
    )
  );
